import { z } from 'zod';

import { AhqSubmissionCandidateSchema } from './ahq-submission-candidate';
import { AhqSubmissionPositionSchema } from './ahq-submission-position';
import { CandidateOpportunitySchema } from './candidate-opportunities';
import { CandidateReputationClarificationSchema } from './candidate-reputation-clarification';

export const AhqSubmissionCandidateOpportunitySchema =
  CandidateOpportunitySchema.pick({
    baseHourlyCompensation: true,
    candidateStatus: true,
    displayBillingRate: true,
    id: true,
    isActiveForSubmission: true,
    marginApprovalCeiling: true,
    marginApprovalFloor: true,
    meetsMinPayRequirements: true,
    proposedHourlyCompensation: true,
    proposedHourlyCompCandidateCurrency: true,
    proposedHourlyRate: true,
    proposedMarginTarget: true,
    submissionDescription: true,
    submissionRank: true,
  }).extend({
    candidate: AhqSubmissionCandidateSchema,
    enableReputationSharing: z.boolean(),
    position: AhqSubmissionPositionSchema,
    showCandidateReputation: z.boolean().default(false),
    candidateReputationClarification:
      CandidateReputationClarificationSchema.nullable(),
  });

export type AhqSubmissionCandidateOpportunity = z.infer<
  typeof AhqSubmissionCandidateOpportunitySchema
>;
